import React, { useCallback, useEffect, useState } from "react";
import Table from "../Table";
import { GetSale } from "../../redux/Transaction/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import NoData from "../noData";
import useInfiniteScroll from "../Hooks/useInfiniteScroll";

const DashboardSaleTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });

  const [hasMoreData, setHasMoreData] = useState(true);

  const tableData = useSelector((state) => state?.Sale?.saleData?.data);

  const tableHeading = {
    no: <div className="ml-5 text-center  w-10">No.</div>,
    date: <div className="text-center  w-28">Date</div>,
    nonvatsale: <div className="text-center  w-24">Non VAT SALE</div>,
    vatSale: <div className="text-center  w-28">VAT Sale</div>,
    vatAmount: <div className="text-center  w-28">VAT Amount</div>,
    cashAmount: <div className="text-center  w-28">Cash Amount</div>,
    bankAmount: <div className="text-center  w-28">Bank Amount</div>,
    lottery: <div className="text-center  w-20">Lottery</div>,
    payzone: <div className="text-center  w-20 ">Payzone</div>,
    oyester: <div className="text-center  w-20 ">Oyester</div>,
    total: <div className="text-center  w-20 ">Total</div>,
    status: <div className="mr-5 text-center  w-20 ">Status</div>,
  };

  const headData = Object.values(tableHeading);

  const data = tableData?.map((e, index) => {
    return {
      no: <div className="ml-5 text-center w-10">{index + 1}</div>,
      date: (
        <div className="text-center  w-28">
          {dayjs(e?.date).format("DD/MM/YYYY")}
        </div>
      ),
      nonvatsale: <div className="text-center w-24">{e?.nonvatsale}</div>,
      vatSale: <div className="text-center w-28">{e?.vatsale}</div>,
      vatAmount: <div className="text-center w-28">{e?.vatamount}</div>,
      cashAmount: <div className="text-center w-28">{e?.cashamount}</div>,
      bankAmount: <div className="text-center w-28">{e?.bankamount}</div>,
      lottery: <div className="text-center w-20">{e?.lottery}</div>,
      payzone: <div className="text-center w-20">{e?.payzone}</div>,
      oyester: <div className="text-center w-20">{e?.oyester}</div>,
      total: <div className="text-center w-20">{e?.total}</div>,
      status: (
        <div
          className={`${
            e?.status ? "text-green bg-green/10" : "text-textyellow bg-bgyellow"
          } mr-5 text-xs font-normal rounded px-1.5 py-2 w-20 flex items-center justify-center`}
        >
          {e?.status ? "Approved" : "Pending"}
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    dispatch(GetSale({ page: filter?.page, limit: filter?.limit })).then(
      (res) => {
        if (res?.data?.status === 401) {
          navigate("/");
        }
        if (res?.data?.data?.length === 0) {
          setHasMoreData(false);
        }
      }
    );
  }, [dispatch, navigate, filter]);

  return (
    <>
      {tableData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={data}
          rowClass={"text-center"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
    </>
  );
};

export default DashboardSaleTable;
